const helperFunctions = () => {};

const isVisible = (elem) => {
    var scrollTop = $(window).scrollTop();
    var windowBottom = scrollTop + $(window).height();
    var offset = 100;
    var elementTop = elem.offset().top;

    if ( (windowBottom + offset) > elementTop ) {
        return true;
    } else {
        return false;
    }
};

const setCookie = (cname,cvalue) => {
    var date = new Date();
    var expires = 'expires=';
    date.setDate(date.getDate() + 1);
    expires += date.toGMTString();
    document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=/';
};